import { useEffect, useState } from "react";
import { Pause, Play, SkipForward, Square, LogOut, Shuffle, Repeat, Repeat1, RotateCcw, Volume2 } from "lucide-react";
import { Slider } from "@/components/ui/slider";

const LOOP_NEXT = { off: "track", track: "queue", queue: "off" };
const LOOP_LABEL = { off: "Pętla: wył.", track: "Pętla: utwór", queue: "Pętla: kolejka" };

const Btn = ({ onClick, testid, children, title, active, disabled, big }) => (
  <button
    onClick={onClick}
    title={title}
    disabled={disabled}
    data-testid={testid}
    className={`grid place-items-center rounded-full border transition-[background-color,border-color,transform] duration-150 active:scale-95 disabled:opacity-30 disabled:pointer-events-none ${
      big ? "h-14 w-14 bg-emerald-500 hover:bg-emerald-400 border-emerald-400 text-slate-950 shadow-[0_0_30px_rgba(16,185,129,0.35)]"
        : active ? "h-11 w-11 border-emerald-500/60 bg-emerald-500/15 text-emerald-300"
        : "h-11 w-11 border-slate-700 bg-slate-900 hover:bg-slate-800 text-slate-200"
    }`}
  >
    {children}
  </button>
);

export default function PlayerControls({ player, act }) {
  const [vol, setVol] = useState(player?.volume ?? 100);
  useEffect(() => setVol(player?.volume ?? 100), [player?.volume]);
  const on = player?.connected;
  const loop = player?.loop || "off";
  const LoopIcon = loop === "track" ? Repeat1 : Repeat;

  return (
    <div className="mt-6 flex flex-wrap items-center gap-5 justify-between" data-testid="player-controls">
      <div className="flex items-center gap-2.5">
        <Btn testid="shuffle-button" title="Losuj" onClick={() => act("control", "shuffle")} disabled={!on}><Shuffle className="h-4 w-4" /></Btn>
        <Btn testid="replay-button" title="Od początku" onClick={() => act("control", "replay")} disabled={!player?.current}><RotateCcw className="h-4 w-4" /></Btn>
        <Btn big testid="play-pause-button" title={player?.paused ? "Wznów" : "Pauza"} disabled={!player?.current}
          onClick={() => act("control", player?.paused ? "resume" : "pause")}>
          {player?.paused || !player?.current ? <Play className="h-6 w-6 ml-0.5" /> : <Pause className="h-6 w-6" />}
        </Btn>
        <Btn testid="skip-track-button" title="Pomiń" onClick={() => act("control", "skip")} disabled={!player?.current}><SkipForward className="h-4 w-4" /></Btn>
        <Btn testid="loop-mode-button" title={LOOP_LABEL[loop]} active={loop !== "off"} onClick={() => act("loop", LOOP_NEXT[loop])} disabled={!on}>
          <LoopIcon className="h-4 w-4" />
        </Btn>
        <span className="ml-1 text-xs font-mono text-slate-400 w-24" data-testid="loop-mode-label">{LOOP_LABEL[loop]}</span>
      </div>
      <div className="flex items-center gap-3">
        <Volume2 className="h-4 w-4 text-slate-400" />
        <Slider data-testid="volume-slider" className="w-32" value={[vol]} max={200} step={5} disabled={!on}
          onValueChange={([v]) => setVol(v)} onValueCommit={([v]) => act("volume", v)} />
        <span className="text-xs font-mono w-10 text-slate-300" data-testid="volume-value">{vol}%</span>
        <Btn testid="stop-button" title="Stop" onClick={() => act("control", "stop")} disabled={!on}><Square className="h-4 w-4" /></Btn>
        <Btn testid="leave-button" title="Rozłącz" onClick={() => act("control", "leave")} disabled={!on}><LogOut className="h-4 w-4" /></Btn>
      </div>
    </div>
  );
}
